import React from 'react';
import Link from 'next/link';
import { DatabaseBackup } from 'lucide-react';
import AppLogo from '@/components/ui/AppLogo';

export default function Topbar() {
  return (
    <header className="sticky top-0 z-40 w-full bg-card shadow-topbar">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 2xl:px-16 h-16 flex items-center gap-3">
        <Link href="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <AppLogo size={36} />
          <span className="font-semibold text-xl tracking-tight text-foreground hidden sm:block">
            FolhaCaixa
          </span>
        </Link>
        <div className="ml-3 h-5 w-px bg-border hidden sm:block" />
        <span className="text-xs text-muted-foreground font-mono hidden sm:block">V1.0.2</span>
        <div className="ml-auto flex items-center gap-2">
          <Link
            href="/backup"
            className="flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium bg-green-600 text-white hover:bg-green-700 transition-colors"
          >
            <DatabaseBackup className="w-3.5 h-3.5" />
<span className="hidden sm:inline">Backup &amp; Restore</span>
          </Link>
        </div>
      </div>
    </header>
  );
}